// extracted by mini-css-extract-plugin
module.exports = {"spotListItemWrapper":"SpotList_spotListItemWrapper__A1xWn","spotMapHeaderNoResults":"SpotList_spotMapHeaderNoResults__g6CZB"};